/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Launcher_DescInputs */

const en_pc_dl_launcher_desc = /** @type {(inputs: Pc_Dl_Launcher_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ArtCraft Launcher installs PdfCraft and keeps it, and the other Craft apps, up to date.`)
};

const zh_pc_dl_launcher_desc = /** @type {(inputs: Pc_Dl_Launcher_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft Launcher 可以安装 PdfCraft，并让它和其他 Craft 应用保持最新。`)
};

/**
* | output |
* | --- |
* | "The ArtCraft Launcher installs PdfCraft and keeps it, and the other Craft apps, up to date." |
*
* @param {Pc_Dl_Launcher_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_launcher_desc = /** @type {((inputs?: Pc_Dl_Launcher_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Launcher_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_launcher_desc(inputs)
	return zh_pc_dl_launcher_desc(inputs)
});
export { pc_dl_launcher_desc as "pc.dl.launcher_desc" }